export default {"src":"/_next/static/media/OnlyFans.d6f73669.svg","height":33,"width":32,"blurWidth":0,"blurHeight":0};